import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { AbstractSpinControl } from "slotworks/smart-ui/controls/spin/abstract-spin-control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class CancelAutoControl extends AbstractSpinControl {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    protected onButtonPressed() {
        Services.autoplay.stop();
    }
}
